import { useState } from "react";
import { hotList } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

const tabs = [
  "全部",
  "明星八卦",
  "社会热点",
  "娱乐综艺",
  "科技奇闻",
  "体育赛场",
  "民生趣闻",
];

function HotList() {
  const [active, setActive] = useState("全部");

  const list = active === "全部" ? hotList : hotList.filter((i) => i.tag === active);

  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="今日瓜点速览"
          title="全网热榜 TOP 10"
          desc="结合全网讨论量与视频热度实时排序，让你一眼看清明天的瓜在哪里，焦点事件一个不落。"
          linkHref="#video"
          linkLabel="去围观事件视频"
        />

        <div className="mb-6 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActive(tab)}
              className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                active === tab
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <ol className="divide-y divide-background-100">
            {list.map((item, idx) => (
              <li key={`${item.rank}-${item.title}`}>
                <a
                  href="#video"
                  className="group flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 transition-colors hover:bg-background-100/60"
                >
                  <span
                    className={`font-heading shrink-0 text-xl md:text-2xl w-8 text-center ${
                      item.rank <= 3
                        ? "text-accent-500"
                        : "text-foreground-300"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="hidden sm:inline-flex rounded bg-secondary-100 px-2 py-0.5 text-xs whitespace-nowrap text-secondary-900">
                        {item.tag}
                      </span>
                      <span className="hidden sm:inline text-xs text-foreground-400 whitespace-nowrap">
                        {item.time}
                      </span>
                    </div>
                    <p className="mt-1 line-clamp-1 text-sm md:text-base text-foreground-800 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </p>
                  </div>

                  <div className="hidden md:flex flex-col items-end gap-1">
                    <span className="flex items-center gap-1 text-sm text-primary-700">
                      <i className="ri-fire-fill text-accent-500" aria-hidden="true"></i>
                      {item.heat}万热度
                    </span>
                    <div className="h-1.5 w-28 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                  </div>

                  <i
                    className={`shrink-0 text-lg ${
                      item.trend === "up"
                        ? "ri-arrow-up-line text-accent-500"
                        : "ri-arrow-down-line text-foreground-300"
                    }`}
                    aria-hidden="true"
                  ></i>
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default HotList;